export const DOCX_DROPZONE_ACCEPT = {
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
		'.docx',
	],
	'application/msword': ['.doc'],
}

export const isDocWordFile = (file: File) => {
	if (/\.docx?$/i.test(file.name)) return true

	const mime = String(file.type || '').toLowerCase()
	return (
		mime === 'application/msword' ||
		mime ===
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
	)
}

export const pickDocWordFiles = (files: File[]) => files.filter(isDocWordFile)
